import { getCampaignMetricByType } from 'actions/campaignMetrics'
import { alert } from 'actions/flash'
import { getLocations } from 'actions/location'
import useDispatch from 'hooks/useDispatch'
import type { Fields as Campaign } from 'models/Campaign'
import { Type as MetricType, UserCountMetric } from 'models/CampaignMetric'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { selectCampaignMetricByType } from 'selectors/campaignMetric'
import { selectLocation, selectLocationsByIds } from 'selectors/location'
import { selectCurrentMerchantLocations } from 'selectors/location'
import View from './View'

type Props = {
  campaign: Campaign
}

const Audience: React.FC<Props> = ({ campaign }) => {
  const [isLoadingLocations, setIsLoadingLocations] = useState(true)
  const [isLoadingUserCount, setIsLoadingUserCount] = useState(true)

  const selectedLocations = useSelector(state =>
    selectLocationsByIds(state, campaign.config_target_location_ids)
  )
  const selectedLocation = useSelector(state =>
    selectLocation(state, campaign.config_location_id)
  )
  const locations = useSelector(selectCurrentMerchantLocations)
  const userCountMetric = useSelector(
    state =>
      selectCampaignMetricByType(
        state,
        campaign.id,
        MetricType.USER_COUNT
      ) as UserCountMetric | null
  )
  const dispatch = useDispatch()
  const campaignId = campaign.id

  useEffect(() => {
    async function fetchData() {
      const response = await dispatch(getLocations({ coming_soon: false }))
      setIsLoadingLocations(false)

      if (response.error) {
        const error = response.error?.response?.data?.error || null
        dispatch(
          alert({
            key: 'danger',
            message: I18n.t('thanx_campaigns.review.get_metrics_error'),
            error,
            displayDetails: false,
          })
        )
      }
    }

    fetchData()
  }, [dispatch])

  useEffect(() => {
    async function reloadUserCount() {
      const campaignMetricResponse = await dispatch(
        getCampaignMetricByType(campaignId, 'user_count')
      )
      setIsLoadingUserCount(false)

      if (campaignMetricResponse.error) {
        const error =
          campaignMetricResponse.error?.response?.data?.error || null
        dispatch(
          alert({
            key: 'danger',
            message: I18n.t('thanx_campaigns.review.get_metrics_error'),
            error,
            displayDetails: false,
          })
        )
      }
    }

    reloadUserCount()
  }, [selectedLocations, selectedLocation, dispatch, campaignId])

  const isLoading = isLoadingLocations || isLoadingUserCount
  return (
    <View
      isLoading={isLoading}
      locations={locations}
      selectedLocation={selectedLocation}
      selectedLocations={selectedLocations}
      userCount={userCountMetric?.data?.count || 0}
      campaign={campaign}
    />
  )
}

export default Audience
